/* eslint no-console: 0 */
const _serviceDependencies = ['$rootScope', '$scope', 'Launcher', 'Auth'];

/**
 * @ngdoc service
 * @name controllers.NotAllowed
 *
 * @description
 * NotAllowed controller
 */
class NotAllowed {

    /**
     * @param  {any} $rootScope
     * @param  {any} $scope
     * @param  {any} Launcher
     */

    constructor($rootScope, $scope, Launcher, Auth) {

        $rootScope.State.loading = false;
        $rootScope.State.finishedLoadingAnimation = true;
        $scope.brandName = CWCONFIG.partnerConfig.name;

        try {

            Launcher.resizeModal(650, 499);
            $scope.isLauncherWindow = (window.outerWidth === 650 && window.outerHeight === 499);

        } catch (err) {

            console.log(`${err.message} - Not Allowed Page Opened from browser`);

        }

        this.closeLauncher = () => {

            Launcher.closeModal();

        };

        this.removeLoginCookies = () => {

            Auth.removeLoginCookies();

        };

    }

}

_serviceDependencies.push(NotAllowed);

angular.module('controllers')
    .controller('NotAllowed', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/landing-pages/not-allowed/not-allowed.js